import React, { Component } from "react";
import { Link } from "react-router-dom";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import moment from "moment";
import unAuthorizedError from "../Errors/unAuthorizedError";
import Loader from "../UI Component/Loader/Loader";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

class DoctorInstantConsult extends Component {
  state = { loading: false };

  componentWillMount() {
    this.setState({ loading: true });
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("consultation_id");
    localStorage.setItem("cid", id);
    if (
      localStorage.getItem("id_token") &&
      localStorage.getItem("user_type") === "doctor"
    ) {
      afterLoginApiAxios({
        method: "post",
        url: "/patient/patient_consult_tracking",
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          instant_consult_id: localStorage.getItem("cid"),
        },
      })
        .then((res) => {
          C2CConsole.log(res);
          if (res.data.statusCode === 200) {
            this.setState({ loading: false });
            const data = res.data.data.appointment_data;
            this.props.history.push({
              pathname: "/doctor/video",
              state: { app_id: data },
            });
          }
        })
        .catch((err) => C2CConsole.log(err));
    } else {
      unAuthorizedError(() => {
        this.props.history.push("/doctor/login");
      });
    }
  }

  componentDidMount() {}

  render() {
    return <div>{this.state.loading ? <Loader /> : null}</div>;
  }
}

export default DoctorInstantConsult;
